import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import api from '@services/api';

import moment from 'moment';

const options: ApexOptions = {
  chart: {
    toolbar: {
      show: true,
      offsetX: 0,
      offsetY: 0,
      export: {
        csv: {
          filename: 'deviceSince',
          columnDelimiter: ',',
          headerCategory: 'category',
          headerValue: 'value',
        },
        svg: {
          filename: 'deviceSince',
        },
        png: {
          filename: 'deviceSince',
        },
      },
      autoSelected: 'zoom',
    },
    zoom: {
      enabled: true,
      type: 'x',
      autoScaleYaxis: false,
      zoomedArea: {
        fill: {
          color: '#90CAF9',
          opacity: 0.4,
        },
        stroke: {
          color: '#0D47A1',
          opacity: 0.4,
          width: 1,
        },
      },
    },
  },
  plotOptions: {
    bar: {
      borderRadius: 0,
      dataLabels: {
        position: 'center',
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  title: {
    text: 'Total number of registered devices',
    align: 'center',
    margin: 20,
    offsetX: 20,
    offsetY: -10,
    floating: true,
    style: {
      fontSize: '15px',
      fontWeight: '500',
      fontFamily: 'Montserrat',
      color: '#29323FDD',
    },
  },
  xaxis: {
    categories: [],
    type: 'datetime',

    tickAmount: 'dataPoints',
    position: 'bottom',
    min: undefined,
    max: undefined,
    axisBorder: {
      show: true,
    },
    labels: {
      hideOverlappingLabels: true,
      showDuplicates: false,
      show: true,
      trim: true,
      maxHeight: 100,
      style: {
        fontSize: '10px',
        fontFamily: 'Montserrat',
        fontWeight: 400,
      },
      datetimeUTC: false,
      datetimeFormatter: {
        year: 'yyyy',
        month: "MMM 'yy",
        day: 'dd MMM',
      },
    },
  },
  yaxis: {
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    labels: {
      show: true,
    },
  },
  noData: {
    text: 'Loading...',
    align: 'center',
    verticalAlign: 'middle',
    offsetX: 0,
    offsetY: 0,
    style: {
      color: '#0080FFDD',
      fontSize: '14px',
      fontFamily: 'Montserrat',
    },
  },
  tooltip: {
    enabled: true,
    enabledOnSeries: undefined,
    shared: true,
    followCursor: false,
    intersect: false,
    inverseOrder: false,
    custom: undefined,
    fillSeriesColor: false,
    theme: 'dark',
    style: {
      fontSize: '14px',
      fontFamily: 'Montserrat',
    },
    onDatasetHover: {
      highlightDataSeries: false,
    },
  },
  series: [
    {
      name: 'Devices',
      data: [],
    },
  ],
};

const DevicesCounter = () => {
  const [chart, setChart] = React.useState<ApexOptions>(options);

  React.useEffect(() => {
    api.reports.getAllDevicesCounter().then((visit) => {
      if (visit) {
        const dataObj = Object.values(visit.elements || []);
        const count = dataObj.map(({ count }) => count);
        const dataTime = dataObj.map((date) => moment(date.date).format('YYYY-MM-DD'));
        if (dataTime.length) {
          setChart({
            ...chart,
            series: [
              {
                ...chart.series,
                data: count,
              },
            ],
            xaxis: {
              ...chart.xaxis,
              categories: dataTime,
            },
          });
        }
      }
    });
  }, []);

  return (
    <div>
      <ReactApexChart options={chart} series={chart.series} type="line" height={300} />
    </div>
  );
};

export default React.memo(DevicesCounter);
